export default (editor) => {
  const { document, focusBlock } = editor.value;
  return document.getParent(focusBlock.key).type === 'list_item';
};
